import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {SelectedFilterValuesModel} from '../../../dialogs/grid-filter/selected-filter-values.model';
import {LookupModel} from '../../../api/models/lookup-model';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardComponent } from '../../../core/visual/card/card.component';
import { MatSimpleSelectComponent } from '../../../editors/mat-simple-select/mat-simple-select.component';

export interface AuditFilterDialogData {
  filter: Array<SelectedFilterValuesModel>;
  types: LookupModel[];
  categories: LookupModel[];
  users: LookupModel[];
}

@Component({
    selector: 'app-audit-list-filter-dialog',
    templateUrl: './audit-list-filter-dialog.component.html',
    styleUrls: ['./audit-list-filter-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        FlexModule,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardComponent,
        MatSimpleSelectComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class AuditListFilterDialogComponent implements OnInit, OnDestroy {

  filterType = '';
  filterCategory = '';
  filterUserId = '';

  constructor(public dialogRef: MatDialogRef<AuditListFilterDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: AuditFilterDialogData) {
  }

  ngOnInit() {
    if (this.data.types.findIndex(x => !x.id) < 0) {
      this.data.types.unshift({intId: 0, id: '', text: 'Any Type'});
    }
    if (this.data.categories.findIndex(x => !x.id) < 0) {
      this.data.categories.unshift({intId: 0, id: '', text: 'Any Category'});
    }
    if (this.data.users.findIndex(x => !x.id) < 0) {
      this.data.users.unshift({id: '', text: 'Any User'});
    }

    if (this.data.filter) {
      for (const selectedFilter of this.data.filter) {
        if (selectedFilter.filterKey === 'type') {
          this.filterType = selectedFilter.values[0];
        } else if (selectedFilter.filterKey === 'category') {
          this.filterCategory = selectedFilter.values[0];
        } else if (selectedFilter.filterKey === 'customerUserId') {
          this.filterUserId = selectedFilter.values[0];
        }
      }
    }
  }

  ngOnDestroy() {
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      const filter: SelectedFilterValuesModel[] = [];

      if (this.filterType) {
        const item = this.data.types.find(x => x.id === this.filterType);
        if (item) {
          filter.push({
            filterKey: 'type',
            title: 'Type',
            multiValue: false,
            values: [item.id],
            displayValues: [item.text]
          });
        }
      }

      if (this.filterCategory) {
        const item = this.data.categories.find(x => x.id === this.filterCategory);
        if (item) {
          filter.push({
            filterKey: 'category',
            title: 'Category',
            multiValue: false,
            values: [item.id],
            displayValues: [item.text]
          });
        }
      }

      if (this.filterUserId) {
        const item = this.data.users.find(x => x.id === this.filterUserId);
        if (item) {
          filter.push({
            filterKey: 'customerUserId',
            title: 'User',
            multiValue: false,
            values: [item.id],
            displayValues: [item.text]
          });
        }
      }

      this.dialogRef.close(filter);
    }
  }
}
